export const KPL_FINANCIAL_API = `v1/financial-reporting/kpl`;
